import { useEffect } from "react";
import UsePostmortemInfo from "../../context/PostmortemContext";
import { useHandleOnBoardingStates } from "./states";

import useFillOnbaordingInputs from "./hooks/useFillOnbaordingInputs";
import { useUpdateMacOptions } from "../../customhooks/useUpdateMacOptions";
import {FetchAndSetMacOptions} from "../../customhooks/handlers/FetchAndSetMacOptions";
import HandleSelectionChange from "../../customhooks/handlers/handleChangeMacOptions";
import { useFetchMacDataBasedOnAppId } from "../../customhooks/useFetchMacDataBasedOnAppId";
import { postmortemApiEndpoint } from "../../config";
// import { useWebSocket } from "../../context/WebSocketContext/WebSocketContext";
import { useMsal } from "@azure/msal-react";
import UserInfo from "../../context/UserAccessContext";




export const UseOnboarding = () =>
  {
    const apiEndpoint = postmortemApiEndpoint;
    const { postmortemState, memoizedDispatch,   appOptionsAvailable,
      setAppOptionsAvailable, lockedFields, collaborators, setCollaborators, postmortemTeamId, currentPostmortemObject } = UsePostmortemInfo();

    // const {
    //   lockField,
    //   unlockField,
    // }   = useWebSocket();
    const lockField = null; // WebSocket disabled
    const unlockField = null; // WebSocket disabled

 const { graphData } = UserInfo();
 const { instance, accounts } = useMsal();

    //required states which are defined in states.js
    const {
      selectedOnboardingOptions,
      onboardingOptions,
      loadingStates,
      errorStates,
      setSelectedOnboardingOptions,
      setLoadingStates,
      setErrorStates,
      setOnboardingOptions,
      macAppId,
      setMacAppId,
     
    } = useHandleOnBoardingStates();


    //class which will fetch and set the onboarding options for the dropdowns by calling mac apis
    const fetchAndSetHandler = new FetchAndSetMacOptions(
      setOnboardingOptions,
      setLoadingStates,
      setErrorStates,
      apiEndpoint
    );



    //class which will fetch and set the onboarding option for portfolio dropdowns by calling mac apis, 
    //only functional on first render of the component
    useUpdateMacOptions(fetchAndSetHandler.fetchAndSetOptions, "", "portfolio", setAppOptionsAvailable, appOptionsAvailable)

    //class which will fetch and set the onboarding option for platform dropdowns by calling mac apis,
    // only functional  when "selectedOnboardingOptions?.selectedPortfolio?.id" is changed
    useUpdateMacOptions(fetchAndSetHandler.fetchAndSetOptions, selectedOnboardingOptions?.selectedPortfolio?.id, "platform", setAppOptionsAvailable, appOptionsAvailable)
    
    //class which will fetch and set the onboarding option for product dropdowns by calling mac apis
    // only functional when "selectedOnboardingOptions?.selectedPlatform?.id" is changed
    useUpdateMacOptions(fetchAndSetHandler.fetchAndSetOptions,selectedOnboardingOptions?.selectedPlatform?.id, "product", setAppOptionsAvailable, appOptionsAvailable)
    
    //class which will fetch and set the onboarding option for app dropdowns by calling mac apis
    // only functional  when "selectedOnboardingOptions?.selectedProduct?.id" is changed
    useUpdateMacOptions(fetchAndSetHandler.fetchAndSetOptions,selectedOnboardingOptions?.selectedProduct?.id, "app", setAppOptionsAvailable, appOptionsAvailable)



    // Functions that will handle the change event on each dropdowns
    // Do following when there's a change event on the dropdowns
    // 1 - Update the context state with the selected value
    // 2 - Update the local state with the selected value
    const {
      handleSelectedPortFolioChange,
      handleSelectedPlatformChange,
      handleSelectedProductChange,
      handleSelectedAppChange,
      handleMacAppIdChange,
      handleMvcVulnerabilityChange
    } = HandleSelectionChange(
      setSelectedOnboardingOptions,
      setErrorStates,
      memoizedDispatch,
      setMacAppId
    );


    //Functions that will be called on the first render of the component to fill the dropdowns with the context state information,
    const { getDataToFillFor, setDataFor } = useFillOnbaordingInputs(
      onboardingOptions,
      postmortemState,
      setSelectedOnboardingOptions
    );

    useEffect(() => {
      if(postmortemState){
  
        let macAppId = postmortemState.application_id.value;
        if(macAppId){
          setMacAppId(macAppId)
        }
      }
    
    }, [postmortemState])

    //useEffect to fill portfolio dropdowns with the context state information,  or if there's any change in the context state
    useEffect(() => {

      let portfolioData = getDataToFillFor("portfolio");
      if (postmortemState) setDataFor("selectedPortfolio", portfolioData);
    }, [
      postmortemState,
      onboardingOptions.portfolio,
      setDataFor,
      getDataToFillFor,
    ]);

     //useEffect to fill platform dropdowns with the context state information,  or if there's any change in the context state
    useEffect(() => {

      let platformData = getDataToFillFor("platform");
      if (postmortemState) setDataFor("selectedPlatform", platformData);
      // setPlatforms();
    }, [
      postmortemState,
      onboardingOptions.platform,
      getDataToFillFor,
      setDataFor,
    ]);

    
     //useEffect to fill product dropdowns with the context state information,  or if there's any change in the context state
    useEffect(() => {

      let productData = getDataToFillFor("product");
      if (postmortemState) setDataFor("selectedProduct", productData);
    }, [
      postmortemState,
      onboardingOptions.product,
      getDataToFillFor,
      setDataFor,
    ]);


    //useEffect to fill app dropdowns with the context state information, or if there's any change in the context state
    useEffect(() => {
    
      let appData = getDataToFillFor("app");

      if(appData && appData.id)setAppOptionsAvailable(true)
      if (postmortemState) setDataFor("selectedApp", appData);
    }, [postmortemState, onboardingOptions.app, getDataToFillFor, setDataFor]);

    //useEffect to fill MVC Vulnerability Related field with the context state information
    useEffect(() => {
      if (postmortemState && postmortemState.mvcVulnerabilityRelated) {
        setDataFor("mvcVulnerabilityRelated", postmortemState.mvcVulnerabilityRelated);
      }
    }, [postmortemState, setDataFor]);

    const { macData, macError, macLoading, refetchMacData } =
    useFetchMacDataBasedOnAppId(macAppId);




    //update the dropdowns with the information fetched by using mac APP ID
    useEffect(() => {
      // Use the data from the hook

      if (macData) {
        // setDataFor("selectedPortfolio",  {id:null, label:macData.portFolioName,value:macData.portFolioName});
        handleSelectedPortFolioChange({id:null, label:macData.portFolioName, value:macData.portFolioName});
        // setDataFor("selectedPlatform",{id:null, label:macData.platformName, value:macData.platformName});
        handleSelectedPlatformChange({id:null, label:macData.platformName, value:macData.platformName});
        // setDataFor("selectedProduct",{id:null, label:macData.productName, value:macData.productName} );
        handleSelectedProductChange({id:null, label:macData.productName, value:macData.productName});
        // setDataFor("selectedApp",{id:null, label:macData.applicationName, value:macData.applicationName});
        if(macData.applicationName){
          setAppOptionsAvailable(true)
          handleSelectedAppChange({id:macAppId, label:macData.applicationName, value:macData.applicationName});
        }
        // Minimal integration: call global helper to auto-add APMT owners when macData arrives.
  // Auto-add of MAC owners is performed after the postmortem is saved.
  // Previous immediate invocation was removed to avoid premature adds while editing.
      }
    }, [macData]); // Only run this effect if macData changes
    
    useEffect(() => {
      // Handle error
      if (macError) {
      }
    }, [macError]);

   

    return {
      handleSelectedPortFolioChange,
      handleSelectedPlatformChange,
      handleSelectedProductChange,
      handleSelectedAppChange,
      handleMvcVulnerabilityChange,
      onboardingOptions,
      loadingStates,
      errorStates,
      selectedOnboardingOptions,
      macAppId,
      handleMacAppIdChange,
      macLoading,
      macError,
      appOptionsAvailable,
      lockField,
      unlockField,
      graphData,
      lockedFields
    };
  };
